/**
 * Maps a payment_status to a `status-*` CSS class for the .status-badge component.
 * Replaces nested ternary expressions that were used in several pages.
 */
export function paymentStatusClass(status) {
  if (status === "paid") return "status-paid";
  if (status === "failed") return "status-failed";
  return "status-pending";
}
